import React, { useState } from 'react';
import axios from 'axios';
import { CheckCircle2 } from 'lucide-react';
import { toast } from 'sonner';
import { Input } from '../ui/input';
import { Button } from '../ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ProductCheck = ({ conn, params, onDone, onClose }) => {
  const [items, setItems] = useState(['', '', '']);
  const [results, setResults] = useState(null);
  const [busy, setBusy] = useState(false);

  const run = async (e) => {
    e.preventDefault(); setBusy(true);
    const out = [];
    for (const q of items.filter((x) => x.trim())) {
      try { out.push({ q, ...(await axios.post(`${API}/business/api-connections/${conn.id}/test`, { query: q }, { params })).data }); }
      catch (err) { out.push({ q, ok: false, result: err.response?.data?.detail?.toString() || 'Check failed' }); }
    }
    setResults(out); setBusy(false);
  };
  const confirm = async () => {
    try { await axios.post(`${API}/business/api-connections/${conn.id}/confirm`, {}, { params }); toast.success("Great, your Pro is ready to answer stock questions"); onDone(); }
    catch { toast.error('Could not save'); }
  };

  return (
    <div className="rounded-xl border border-primary/40 bg-primary/5 p-4 space-y-3" data-testid={`product-check-${conn.id}`}>
      <div>
        <p className="font-semibold text-foreground">Last step: check it with 3 of your products</p>
        <p className="text-sm text-muted-foreground">Type 3 things customers often ask about. We'll show you exactly what your Pro would see, so you can make sure it's right.</p>
      </div>
      <form onSubmit={run} className="grid sm:grid-cols-4 gap-2">
        {items.map((v, i) => (
          <Input key={i} value={v} required={i === 0} placeholder={['e.g. red roses', 'e.g. 225/65R17 tires', 'e.g. brake pads'][i]}
            onChange={(e) => setItems(items.map((x, j) => (j === i ? e.target.value : x)))} data-testid={`product-check-input-${i}`} />
        ))}
        <Button type="submit" disabled={busy} data-testid="product-check-run-btn">{busy ? 'Checking...' : 'Check'}</Button>
      </form>
      {results && (
        <div className="space-y-2" data-testid="product-check-results">
          {results.map((r, i) => (
            <div key={`${i}-${r.q}`} className={`text-xs rounded-lg p-3 break-all max-h-32 overflow-auto ${r.ok ? 'bg-background border border-border text-muted-foreground' : 'bg-red-50 text-red-800'}`}>
              <p className="font-semibold text-foreground mb-1">"{r.q}"</p>{r.result}
            </div>
          ))}
          <div className="flex flex-wrap gap-2 items-center">
            <Button onClick={confirm} data-testid="product-check-confirm-btn"><CheckCircle2 className="w-4 h-4 mr-1" /> Yes, this looks right</Button>
            <Button variant="ghost" onClick={onClose} data-testid="product-check-close-btn">Not right, I'll fix it</Button>
          </div>
          <p className="text-xs text-muted-foreground">Not right? Check the link points to the page with your stock list, or email support@frontdeskpro.org.</p>
        </div>
      )}
    </div>
  );
};
